'use strict';

/**
 *
 * @name: googleplusShare
 *
 */

function GoogleplusShareDirective($rootScope, $location, campaignTrackingServ) {

  'ngInject';

  return {
    restrict: 'A',
    link: function(scope, element, attrs) {

      element.click(function() {

        var descriptionText;

        if (attrs.description) {

          descriptionText = attrs.description;
        }

        var width = 600;
        var height = 600;
        var left = ($(window).width() - width) / 2;
        var top = ($(window).height() - height) / 2;
        var url;

        if (scope.post) {

          var addressToShare = encodeURIComponent($location.protocol() + '://' + $location.host() + '/story/' + scope.post.translations[$rootScope.lang].slug);

          if (scope.post.series) {

            addressToShare = encodeURIComponent($location.protocol() + '://' + $location.host() + '/series/' + scope.post.series.translations[0].slug + '/' + scope.post.translations[$rootScope.lang].slug);
          }

          url = 'https://plus.google.com/share' +
            '?url=' + addressToShare;
        } else {

          url = 'https://plus.google.com/share' +
            '?url=' + encodeURIComponent($location.protocol() + '://' + $location.host() + $location.path());
        }

        if (attrs.trackingUrl && attrs.trackingUrl.toLowerCase() === 'true') {

          var medium = attrs.trackingUrlMedium || 'desktop';
          url += '?' + encodeURIComponent(campaignTrackingServ.generateTrackingParams('googleplus', medium, 'share'));
        }

        var opts = 'status=1' +
          ',menubar=no,toolbar=no,resizable=yes,scrollbars=yes' +
          ',width=' + width +
          ',height=' + height +
          ',top=' + top +
          ',left=' + left;

        window.open(url, 'Google+', opts);

        return false;
      });
    }
  };
}

export default GoogleplusShareDirective;



// WEBPACK FOOTER //
// ./app/components/nn-social/nn-google-plus-share.directive.js